var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1 0v1.5l.682.569A4.967 4.967 0 013.5 1.525V0zm3.5 0v1.525a4.968 4.968 0 011.819.544L7 1.5V0zM3.338 5.59l-1.478.215 1.07 1.043-.253 1.472L4 7.625l1.323.696-.253-1.473 1.07-1.043-1.478-.215L4 4.25zM4 3.5a3 3 0 110 6 3 3 0 010-6zm-4 3a4 4 0 108 0 4 4 0 00-8 0z"
  })));
}
export default __webpack_public_path__ + "static/svg/medal-icon.svg";
export { SvgMedalIcon as ReactComponent };